import { createContext } from 'react';

import type {
  StudyPlanFrequencyEnum,
  StudyPlanTargetEnum,
} from '@/shared/types/graphql/globals';

import type { StudyPlan, StudyPlanState } from '../types';

export interface StudyPlanContextType
  extends Pick<StudyPlanState, 'mutationStatus'> {
  currentView: 'edit-view' | 'changes-saved-view';
  changeCurrentView: (view: 'edit-view' | 'changes-saved-view') => void;
  loading: boolean;
  studyPlan: StudyPlan;
  queryError: boolean;
  onRefetch: () => void;
  isUpdateMode: boolean;
  onTargetChange: (newTarget: StudyPlanTargetEnum) => void;
  onFrequencyChange: (newFrequency: StudyPlanFrequencyEnum) => void;
  onNotificationsEnabledChange: (enabled: boolean) => void;
  onSave: () => void;
}

export const defaultContext: StudyPlanContextType = {
  currentView: 'edit-view',
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentionally empty block
  changeCurrentView: () => {},
  loading: false,
  studyPlan: {
    target: undefined,
    frequency: undefined,
    notificationsEnabled: false,
  },
  queryError: false,
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentionally empty block
  onRefetch: () => {},
  isUpdateMode: false,
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentionally empty block
  onTargetChange: () => {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentionally empty block
  onFrequencyChange: () => {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentionally empty block
  onNotificationsEnabledChange: () => {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentionally empty block
  onSave: () => {},
  mutationStatus: { status: 'initial', errorMessage: '' },
};

const StudyPlanContext = createContext<StudyPlanContextType>(defaultContext);

export default StudyPlanContext;
